<template>
  <div class="expression-editor" :class="{ 'has-changes': canSave, 'custom-expression-wrapper': isCustomExpression }">
		<div class="editor-header">
			<h4 style="line-height: 25px">{{$t('editor-expression.condition-title')}}</h4>
			<div class="header-actions">
				<div class="toggle-btns">
					<button class="btn btn-xs" :class="{ 'active': !isCustomExpression }" @click="toggleCustom">{{$t('editor-expression.simple-condition')}}</button>
					<button class="btn btn-xs" :class="{ 'active': isCustomExpression }" @click="toggleCustom">{{$t('editor-expression.advanced-condition')}}</button>
				</div>
				<div class="trash" @click.stop="$emit('remove')">
					<i class="fa-light fa-trash"></i>
				</div>	
			</div>
		</div>

		<div v-if="loadingFormats"  class="d-flex flex-grow-1 align-items-center justify-content-center">
			<p style="margin: 10px;">{{$t('loading')}}... </p> 
		</div>
		<div v-else-if="formatValueError" class="d-flex flex-grow-1 align-items-center justify-content-center" >
			<p style="margin: 10px;">{{$t('editor-expression.format-error')}}</p>
			<br/>
			<button class="btn btn-secondary" style="margin-right: 4px;" @click="advanceFromError">{{$t('advance')}}</button>
			<button class="btn btn-secondary" @click="onClose">{{$t('close')}}</button>
		</div>
		<div v-else>
		
		<div v-if="isCustomExpression" class="d-flex flex-column">
			<custom-expression-editor
				class="editor-step"
				:expression="parsedExpression.customExpression"
				:expressionObject="leftObject"
				@expression-changed="onCustomExpressionChanged"
				@close="$emit('close')"
			/>
		</div>
		
		<div v-else style="position:relative;">
			<div class="step-one">
				<div class="step-one-result" v-if="parsedExpression.leftHandFormattedVariable || parsedExpression.leftHandVariable" >
					<div style="padding: 10px 0 10px 20px;">

						<div @click="resetLeftHand" class="ellipsis">
							<span class="var-desc">{{$t('editor-expression.chosen-var1')}} </span>	
							<span  >{{parsedExpression.leftHandVariable.displayName || parsedExpression.leftHandVariable.name.substr(1, parsedExpression.leftHandVariable.name.length -2)}} <i class="fa-light fa-undo undo-icon"></i> </span><br>
						</div>

						<div style="display: flex; align-items: center; justify-content: space-between;">
							<span class="result-value ellipsis">{{parsedExpression.leftHandFormattedVariable ? parsedExpression.leftHandFormattedVariable.value || $t('editor-expression.no-value') :  parsedExpression.leftHandVariable.value || $t('editor-expression.no-value')}}</span>
							<div v-if="parsedExpression.leftHandVariable">
									<!-- <button style="margin: 0 10px;" class="btn btn-secondary btn-xs" @click="getFormatExamples(parsedExpression.leftHandVariable, 'left')">Format</button> -->
									<button style="margin: 0 10px;" class="btn btn-xs" :class="showFormattingLeft && formattedLeft ? 'btn-primary' : 'btn-secondary' " @click="showFormattingLeft = !showFormattingLeft, showFormattingRight = false">{{showFormattingLeft ? $t('editor-expression.format-done') : $t('editor-expression.format-format')}}</button>
							</div>
						</div>

					</div>
						<variable-formats 
							v-if="showFormattingLeft"
							class="formatter formatter-left custom-scrollbar-grey"
							:variable="parsedExpression.leftHandVariable"
							:format="parsedExpression.leftHandFormattedVariable ? parsedExpression.leftHandFormattedVariable.format : ''"
							:whitelist="true"
							@format-changed="onFormatChangedLeft"
						/>			
				</div>
					<variable-selector
						:title="$t('editor-expression.var-title1')"
						:class="parsedExpression.leftHandVariable ? 'collapsed' : ''"
						class="editor-step"	
						:variable-groups="$store.getters.variableGroups"
						:selected-variable-name="!isCustomExpression && parsedExpression.leftHandVariable ? parsedExpression.leftHandVariable.name : null"
						@variable-name-changed="onLeftHandChanged"
					/>
			</div>
			
			<div class="placeholder-wrapper">
				<div class="operator-placeholder" v-if="!parsedExpression.leftHandVariable"> {{$t('operator-selector.title')}} </div>
				<span class="hover-placeholder"> <p> {{$t('editor-expression.hover-placeholder')}}</p></span>
			</div>
			<div class="step-two" v-if="parsedExpression.leftHandVariable">
				<div class="step-two-result" v-if="parsedExpression.operator" @click="parsedExpression.operator = null, showFormattingRight = false" >
					<span class="var-desc">{{$t('editor-expression.chosen-op')}}</span>
					<span >{{parsedExpression.operator.title}}</span>
				</div>
				<operator-selector
				:class="parsedExpression.operator ? 'collapsed' : ''"
				style="width: auto !important;"
				class="editor-step"
				:selected-operator="parsedExpression.operator"
				:variable-type="parsedExpression.leftHandFormattedVariable ? parsedExpression.leftHandFormattedVariable.type : parsedExpression.leftHandVariable.type"
				@operator-changed="onOperatorChanged"
				/>
			</div>

		
			<div class="step-three" v-if="parsedExpression.leftHandVariable && parsedExpression.operator || parsedExpression.rightHandVariable ">			
				<div class="step-three-result"  v-if="parsedExpression.rightHandVariable" :class="parsedExpression.rightHandVariable.type == 'List' && !formattedRight ? 'unsupported-small' : '' ">
					<div style="padding: 10px 0 10px 20px;">
						<div @click="resetRightHand()" class="ellipsis">
							<span class="var-desc">{{$t('editor-expression.chosen-var1')}} </span>	
							<span  >{{parsedExpression.rightHandVariable.displayName || parsedExpression.rightHandVariable.name.substr(1, parsedExpression.rightHandVariable.name.length -2)}} <i class="fa-light fa-undo undo-icon"></i> </span><br>
						</div>
				
						<div style="display: flex; align-items: center; justify-content: space-between;">
							<span class="result-value ellipsis">{{parsedExpression.rightHandFormattedVariable ? parsedExpression.rightHandFormattedVariable.value || $t('editor-expression.no-value') :  parsedExpression.rightHandVariable.value || $t('editor-expression.no-value')}}</span>
							<div v-if="parsedExpression.rightHandVariable">
								<button style="margin: 0 10px;" class="btn btn-xs" :class="showFormattingRight && formattedRight ? 'btn-primary' : 'btn-secondary' " @click="showFormattingRight = !showFormattingRight">{{showFormattingRight ? $t('editor-expression.format-done') : $t('editor-expression.format-format')}}</button>
							</div>
						</div>
					</div>

					<div v-if="showFormattingRight">
						<variable-formats 
							class="formatter formatter-right custom-scrollbar-grey"
							:variable="parsedExpression.rightHandVariable"
							:format="format"
							:whitelist="true"
							@format-changed="onFormatChangedRight"
						/>
					</div>
				</div>
				<variable-selector
					v-if="rightHandNotNeeded == false"
					:title="$t('editor-expression.var-title2')"
					class="editor-step"
					style="height: auto !important;"
					:selected-variable-name="parsedExpression.rightHandVariable ? parsedExpression.rightHandVariable.name: null"
					:show-constant-input="true"
					:variable-groups="$store.getters.variableGroups"
					:constant="parsedExpression.rightHandConstant"
					:constant-error="constantError"
					@constant-changed="onRightHandChanged"
					@variable-name-changed="onRightHandChanged"
					:class="{collapsed :parsedExpression.rightHandVariable, blured :showFormattingLeft}"
				/>
				<!-- <span v-if="parsedExpression.rightHandVariable" @click="parsedExpression.rightHandVariable = null">{{parsedExpression.rightHandVariable.displayName}}</span> -->
			</div>

			<div class="placeholder-wrapper" v-else>
				<div class="var-placeholder" > {{$t('editor-expression.variables')}}</div>
				<span class="hover-placeholder"> <p> {{$t('editor-expression.hover-placeholder2')}}</p></span>
			</div>

			<div class="save-footer" :class="{ 'can-save': canSave && !isList || rightHandNotNeeded == true}">
				<div class="cancel" @click="onClose"> 
					{{$t('editor-expression.cancel')}}
					<i class="fa-light fa-times"></i>
				</div>
				<div class="save" @click="onSave">
					{{$t('editor-expression.save')}}
					<i class="fa-light fa-check"></i>
				</div>
			</div>
			
		</div>
	</div>
  </div>
</template>
<script>
	import VariableSelector from "@/components/VariableSelector";
	import VariableFormatSelector from "@/components/VariableFormatSelector";
	import VariableFormats from '@/components/VariableFormats'
	import OperatorSelector from "@/components/OperatorSelector";
	import CustomExpressionEditor from "@/components/CustomExpressionEditor";
	import VariableHelpers from '@/assets/js/variableHelpers.js'
	import Expression from '@/assets/js/formattedVariable.js'
	// import Expression from '@/assets/js/expression.js'
	import EventBus from '@/assets/js/eventBus.js'
import CheckboxGroupVue from './CheckboxGroup.vue';
	export default {
  name: "expressionEditor",
  props: {
	expression: { type: String },
		format: { type: String }
  },
  data() {
    return {
			canSave: false,
			parsedExpression: null,
			isCustomExpression: false,
			tempExpression: null,
			constantError: false,
			collapsed: false,
			leftObject: null,

			formattedLeft: false,
			formattedRight: false,
			showFormattingLeft: false,
			showFormattingRight: false,
			operatorIsContains: false,

			loadingFormats: false,
			formatValueError: false,
			rightHandNotNeeded: false
		
		}
	},
	methods: {
		handleFormatError(error){
			console.log(error)
			this.loadingFormats = false
			this.formatValueError = true
		},
		advanceFromError(){
			this.formatValueError = false
			this.toggleCustom
			this.parsedExpression = new Expression(this.expression, 'custom')
			this.isCustomExpression = true
		},
		getFormattedValue(groups, formatLeftHand, formatRightHand){
			this.loadingFormats = true
			let leftValue;
			let rightValue;

			if(formatLeftHand && formatRightHand){
					console.log("both has a format")
					this.$store.dispatch('getFormatExamples', {
						variable: this.$store.getters.combinedVariables[VariableHelpers.removeFormatting(groups[1])],
						formats: [VariableHelpers.getFormatting(groups[1])]
					}).then((examplesLeft) => {
							leftValue = examplesLeft
							this.$store.dispatch('getFormatExamples', {
								variable: this.$store.getters.combinedVariables[VariableHelpers.removeFormatting(groups[3])],
							formats: [VariableHelpers.getFormatting(groups[3])]
						}).then((examplesRight) => {
							rightValue = examplesRight
							this.parsedExpression = new Expression(this.expression, this.$store.getters.combinedVariables, leftValue, rightValue)
							this.isCustomExpression = !!this.parsedExpression.customExpression
							this.loadingFormats = false
							this.formattedRight = true
							this.formattedLeft = true
						})
						.catch(error => {this.handleFormatError(error)})
					})
				.catch(error => {this.handleFormatError(error)})
			}
			if(!formatLeftHand && formatRightHand ){
						console.log("only righthand has a format")
				this.$store.dispatch('getFormatExamples', {
						variable: this.$store.getters.combinedVariables[VariableHelpers.removeFormatting(groups[3])],
						formats: [VariableHelpers.getFormatting(groups[3])]
					}).then((examplesRight) => {
						rightValue = examplesRight
						this.parsedExpression = new Expression(this.expression, this.$store.getters.combinedVariables, leftValue, rightValue)
						this.isCustomExpression = !!this.parsedExpression.customExpression
						this.loadingFormats = false
						this.formattedRight = true
						this.formattedLeft = true	
					})
					.catch(error => {this.handleFormatError(error)})
			}
			if(formatLeftHand && !formatRightHand){
						console.log("only lefthand has a format")
					this.$store.dispatch('getFormatExamples', {
						variable: this.$store.getters.combinedVariables[VariableHelpers.removeFormatting(groups[1])],
						formats: [VariableHelpers.getFormatting(groups[1])]
					}).then((examplesLeft) => {
						leftValue = examplesLeft
						this.parsedExpression = new Expression(this.expression, this.$store.getters.combinedVariables, leftValue, rightValue)
						this.isCustomExpression = !!this.parsedExpression.customExpression
						this.loadingFormats = false
						this.formattedLeft = true
					})
					.catch(error => {this.handleFormatError(error)})	 
			}
			if(!formatLeftHand && !formatRightHand){
				console.log("NO formatting")
				this.parsedExpression = new Expression(this.expression, this.$store.getters.combinedVariables, leftValue, rightValue)
				this.isCustomExpression = !!this.parsedExpression.customExpression
				this.loadingFormats = false
			}
		},

		onFormatChangedLeft (format, examples) {
			let example = examples.find((e) => e.format == format)
			this.parsedExpression.formatLeftHand(this.parsedExpression.leftHandVariable.name, example, this.$store.getters.combinedVariables)
			this.canSave = true
			this.formattedLeft = true
		},
		onFormatChangedRight (format, examples) {
			let example = examples.find((e) => e.format == format)
			this.parsedExpression.formatRightHand(this.parsedExpression.rightHandVariable.name, example, this.$store.getters.combinedVariables)
			this.canSave = true
			this.formattedRight = true
		},
		onSave() {
		if (
			this.parsedExpression.rightHandConstant &&
			(this.operatorIsContains === true ||
			["contains", "notcontains"].includes(this.parsedExpression.operator.name)) &&
			(!["'", '"'].includes(this.parsedExpression.rightHandConstant.charAt(0)) ||
			this.parsedExpression.rightHandConstant.charAt(0) != this.parsedExpression.rightHandConstant.slice(-1))
		) {
			this.parsedExpression.rightHandConstant = this.parsedExpression.rightHandConstant.includes("'")
			? `"${this.parsedExpression.rightHandConstant}"`
			: `'${this.parsedExpression.rightHandConstant}'`;
		}
		this.$emit(
			"expression-updated",
			this.isCustomExpression ? this.parsedExpression.customExpression : this.parsedExpression.expression
		);
		this.$emit("close");
		},
		onLeftHandChanged (content) {
			this.isCustomExpression = false
			this.parsedExpression.setLeftHand(content, this.$store.getters.combinedVariables)
			this.canSave = !!this.parsedExpression.isValid
			this.leftObject = this.parsedExpression.leftHandVariable
		},
		onOperatorChanged (operator) {
			this.parsedExpression.setOperator(operator)
			this.canSave = !!this.parsedExpression.isValid
			if(operator == "contains" || operator ==  "notcontains" ){this.operatorIsContains = true }
			else{this.operatorIsContains = false }
		},
		onRightHandChanged (content) {
			this.parsedExpression.setRightHand(content, this.$store.getters.combinedVariables)
			this.canSave = !!this.parsedExpression.isValid
		},
		onRightHandConstantChanged (expression) {
			this.tempExpression = expression
			this.canSave = false
			this.constantError = false
			this.$store.dispatch('testExpression', this.parsedExpression.expression).then(result => {
				if (this.parsedExpression.expression === this.tempExpression) {
					this.canSave = result.valid && this.parsedExpression.isValid					
					this.constantError = !result.valid
					// this.result = result.result
				}
			})

		},
		onCustomExpressionSelected (expression) {
			// the user has chosen to type in an expression manually.
			this.isCustomExpression = true
		},
		onCustomExpressionChanged (expression) {	
			this.parsedExpression.setCustomExpression(expression)
			this.canSave = true
			this.onSave()
		},
		toggleCustom () {
			if (this.isCustomExpression) {
				this.isCustomExpression = false
				this.resetRightHand()
				this.resetLeftHand()
			} else {
				if(this.parsedExpression.rightHandConstant && (this.operatorIsContains === true ||this.parsedExpression.operator.name === "contains" || this.parsedExpression.operator.name === "notcontains")){
					this.parsedExpression.rightHandConstant = `'${this.parsedExpression.rightHandConstant}'`
				}
				this.parsedExpression.setCustomExpression(this.expression || this.parsedExpression.expression)
				this.isCustomExpression = true
			}
		},
		onClose () {
			this.$emit('close')
		},
		resetLeftHand(){
			this.showFormattingRight = false
			this.showFormattingLeft = false
			this.formatted = false, 
			this.parsedExpression.leftHandVariable = null, 
			this.parsedExpression.leftHandFormattedVariable = null,  
			this.examples = []
		},
		resetRightHand(){
			this.showFormattingRight = false
			this.parsedExpression.rightHandVariable = null 
			this.parsedExpression.rightHandFormattedVariable = null 
			this.parsedExpression.rightHandConstant = null
			this.formattedRight = false
		},
		getValueOfExtraVariable(variable, leftHand){
			//Format with nothing to set the value
			const format = [""]
			console.log({variable: variable, formats: format})
			this.$store.dispatch("getFormatExamples", 
				{variable: variable, formats: format} )
				.then((format) => {
						if(format[0].result){
							if(leftHand)  this.$set(this.parsedExpression.leftHandVariable, 'value', variable.type !== 'List' ? format[0].result : format[0].result.split('||')) 
							else  this.$set(this.parsedExpression.rightHandVariable, 'value',  variable.type !== 'List' ? format[0].result : format[0].result.split('||'))
						}
				
			})
		}

	},
	computed: {
		formats () {
			let formats = this.parsedExpression.leftHandVariable.type === 'Date' || this.parsedExpression.leftHandVariable.custom ? [] : [{ name: '', inputValues: {}, description: this.parsedExpression.leftHandVariable.custom ? 'Udregnet værdi' : this.parsedExpression.leftHandVariable.value !== null ? this.parsedExpression.leftHandVariable.value.toString() : 'Variablens værdi', inputs: [] }]
			formats = formats.concat(this.$store.state.variableFormats[this.parsedExpression.leftHandVariable.type.toLowerCase()])
			return formats
		},
		isList(){
			if(this.parsedExpression.rightHandVariable) return this.parsedExpression.rightHandVariable.type == 'List' && !this.formattedRight
			else return false
		},
		expressionTest(){
			return this.parsedExpression.expression
		}
	},
	watch: {
		'parsedExpression.leftHandVariable' (expression) {
			if (this.parsedExpression.leftHandVariable && this.parsedExpression.leftHandVariable.custom == true) {
				this.getValueOfExtraVariable(this.parsedExpression.leftHandVariable, true)
			}
		},
		'parsedExpression.rightHandVariable' (expression) {
			if (this.parsedExpression.rightHandVariable && this.parsedExpression.rightHandVariable.custom == true) {
				this.getValueOfExtraVariable(this.parsedExpression.rightHandVariable)
			}
		},
		'parsedExpression.expression' (expression) {
			if (this.parsedExpression.rightHandConstant != null) {
				this.onRightHandConstantChanged(expression)
			}
		},
		'parsedExpression.operator' (operator) {
			console.log(operator)
			if(!this.parsedExpression.operator){
				this.canSave = false
				this.rightHandNotNeeded = false
				}
			if (this.parsedExpression.operator && ( this.parsedExpression.operator.name == '!=NULL' ||  this.parsedExpression.operator.name == '=NULL')) {
				this.resetRightHand()
				this.rightHandNotNeeded = true
				this.canSave = true
			} else this.rightHandNotNeeded = false
		},
		
		expression: {
			immediate: true,
			handler (expression) {
				// const expressionRegex = /({.*})(!=NULL|=NULL|>=|!=|<=|=|>|<|contains|notcontains)(.*)/g 
				const expressionRegex = /({.*})\s?(!=NULL|=NULL|>=|!=|<=|=|>|<|contains|notcontains)\s?(.*)/g // If spaces in the expression -> error. changed the regex to ignore spaces "\s"
				const betweenExpression = JSON.stringify(expression).match(/(!=NULL|=NULL|>=|!=|<=|=|>|<|contains|notcontains)/g)
				let groups = Array.from(this.expression.matchAll(expressionRegex))
					groups = groups[0]
					
					if(betweenExpression && groups){
						const leftHandIsValidVariable = this.$store.getters.combinedVariables[VariableHelpers.removeFormatting(groups[1])]
						if(leftHandIsValidVariable && VariableHelpers.getFormatting(groups[1]) || (VariableHelpers.isVariable(groups[3]) &&  VariableHelpers.getFormatting(groups[3]) )) {
							const formatLeftHand = VariableHelpers.getFormatting(groups[1])
							const formatRightHand = VariableHelpers.isVariable(groups[3]) ? VariableHelpers.getFormatting(groups[3]) : null
							this.getFormattedValue(groups, formatLeftHand, formatRightHand)
						} else { 
							if(betweenExpression.length > 1){
								// custom expression
								this.parsedExpression = new Expression(this.expression, 'custom')
								this.isCustomExpression = true
							} else{
								this.parsedExpression = new Expression(this.expression, this.$store.getters.combinedVariables)
								this.isCustomExpression = !!this.parsedExpression.customExpression
							}
						}
					} else{
						this.parsedExpression = new Expression(this.expression, this.$store.getters.combinedVariables)
						this.isCustomExpression = !!this.parsedExpression.customExpression
					}
				}
		}
	},
	components: {
		VariableFormats,
		VariableSelector,
		OperatorSelector,
		CustomExpressionEditor
	},
	mounted () {
		EventBus.$on('popover-close', () => this.onClose())
	},
	created(){
		EventBus.$emit('close_preview');
	},
	destroyed(){
		EventBus.$emit('open_preview');
		}
}
</script>

<style lang="less">
	.expression-editor {
			.undo-icon {
				// margin: 0 4px;
				height: 12px;
			}
		.editor-header {
			
			background-color: #fff;
			position: relative;
			z-index: 5;
			color: var(--charcoal) !important;
			letter-spacing: .6px;
			padding: 14px 20px 12px 20px;

			.btn { 
				&:not(.active) {
					color: #8F979C
				}
				
				&+ .btn {
				margin-left: 5px;
				padding: 0.13rem 0.5rem;
				}
			}
			.header-actions{
				display: flex;
				align-items: center;
				justify-content: space-between;
			}
		}

		.editor-step {
			overflow: hidden;
			// overflow: auto;
			transition: .4s;
			box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
			height: 100%;
			position: relative;
			padding: 10px 0;
	
		}

		.collapsed{
			max-height: 0px;
			pointer-events: none;
			margin-bottom: 20px;
		}

		.blured{
			opacity: .5;
			pointer-events: none;
		
		}
		.variable-selector.editor-step.collapsed{
					// margin-bottom: 42px;
					margin-bottom: 46px;
				}

			.result-value{
				font-size: 12px;
				opacity: .7;
				}	


				.unsupported-small{
					// padding: 20px 0 !important;
					.result-value{
						color: var(--red);
					}
				}
			
				.step-one, .step-two, .step-three{
					position: relative;
				}
				.step-two{
					// margin-top: 40px;
					margin-top: 46px;
				}
				
				.step-one-result, .step-two-result, .step-three-result{
					width: 100%;
					position: absolute;
					box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
					// padding: 10px 0 10px 20px ;
					color: #3d464a;
					background: #f5f5f5;
				}
				.step-one-result{
					z-index: 4;
					background: #fff;
				}
				.step-two-result{
					z-index: 3;
					padding: 10px 0 10px 20px ;
				}
				.step-three-result{
					z-index: 2;
					background: #fff;
					
				}
					
				.operator-placeholder, .var-placeholder{
					box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
					padding:10px 10px 0 20px;
					height: 40px;
					font-size: 14px;
					color: #DBDADA;
					background: #f5f5f5;
				}

				.var-placeholder{
					background: #fff;
				}

			.save-wrapper {
				.editor-step {
					padding-bottom: 0px;
					// .vb > div {
					// 	max-height: 200px;
					// }
				}
			}
	.unsupported{
		color: #3d464a;		
		background: #f5f5f5;
		position: absolute;
		height: 100%;
		width: 100%;
		z-index: 10;
		top: 0;
		padding: 20px;
	}
	.hide{
		display: none;
	}

	.placeholder-wrapper{
		position: relative;
	}
		.hover-placeholder{
			cursor:default;
			transition: .5s;
			opacity: 0;
			position: absolute;
			left: 0px;
			bottom: 80%;
			background-color: #666666;
			color: #fafafa !important;
			padding: 5px 10px;
			transform-origin: 0;
			margin: 10px;
			z-index: 999;
			pointer-events: none;
			box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
			p{
				margin: 0;
				padding: 10px 5px;
			}
		}
		.placeholder-wrapper:hover > .hover-placeholder{
			opacity: 1;
			transition-delay: .3s;
			// pointer-events: auto;
		}
		.hover-placeholder:hover{
			opacity: 0 !important;
		}
		.formatter{
			overflow: auto;
			// height: 100% !important;
			padding: 6px 20px;
			background: #f1f1f1;
			box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25),  0px 4px 4px rgba(0, 0, 0, 0.25);
		}
		.formatter-left{
			overflow: auto;
			width: 300px;
			position: fixed;
			top: 212px;
			max-height: calc(100% - 227px);
		}

		.formatter-right{
			overflow: auto;
			width: 300px;
			position: fixed;
			top: 318px;
			max-height: calc(100% - 333px);
		}
		.var-desc{
			width: 100px;
		}

	&.custom-expression-wrapper{
		.editor-header{
			box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
		}
		.editor-step {
			box-shadow: unset;
		}
	}
			
}
	// @media screen and (max-height: 830px){
	// 		.formatter-right{
	// 		overflow: auto;
	// 		width: 300px;
	// 		position: fixed;
	// 		top: 318px;
	// 		max-height: calc(100% - 333px);
	// 	}
	// }
	// 	@media screen and (max-height: 710px){
	// 		.formatter-left{
	// 		overflow: auto;
	// 		width: 300px;
	// 		position: fixed;
	// 		top: 212px;
	// 		max-height: calc(100% - 227px);
	// 	}
	// }
	.custom-expression-editor {
		height: 200px;
	}

	.variable-format {
		// width: 250px;
		padding: 0px 0;
		position: relative;
		background: #f1f1f1;
	}

	.btn.active {
		border: 1px solid var(--orange-web);
		font-weight: 500;
		box-shadow: none !important;
	}

</style>


